import { SAVE_SELECTION_RANGE } from '@/constants/ActionTypes';


export const saveSelectionRange = (selectionRange) => ({
  type: SAVE_SELECTION_RANGE,
  selectionRange,
});
